export enum UPLOAD_TYPES {
  'PDF' = 'PDF',
  'KES' = 'KES',
  'OCR' = 'OCR'
}

export enum ACCEPTED_FORMATS {
  'COMMON' = '.pdf, .docx, .xlsx, .pptx, .rtf, .epub, .alineabook',
  'K3000' = '.pdf, .docx, .xlsx, .pptx, .rtf, .kes, .sek, .epub',
  'OCR' = '.pdf, .jpg, .png',
  'EXAM' = '.pdf, .docx, .xlsx, .pptx',
  'ATTACHMENT' = '.pdf',
}
